import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as c, openBlock as d, normalizeClass as r, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconZohoDesk",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, n = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.891 2.013a.997.997 0 0 0-.749.663 62.42 62.42 0 0 0-.258 1.524c-.257 1.579-.257 1.585-.175 1.826a.991.991 0 0 0 .72.633c.056.012.27.021.473.021.204 0 .37.007.37.015s-.087.538-.192 1.177l-.19 1.162-3.603.01c-3.579.01-3.604.01-3.779.052-.714.167-1.267.585-1.593 1.204-.128.243-.201.48-.26.837C5.14 14.249 4 21.33 4 21.42a.576.576 0 0 0 .745.54c.063-.021.748-.434 1.673-1.007l1.567-.971 3.912-.006c4.277-.007 3.953.002 4.313-.114a2.374 2.374 0 0 0 1.342-1.126c.173-.324.196-.43.474-2.134.181-1.117.252-1.595.243-1.65a.604.604 0 0 0-.3-.435c-.069-.04-.118-.053-.247-.06-.14-.007-.174-.002-.267.04a.6.6 0 0 0-.291.281c-.024.055-.124.616-.281 1.584a45.445 45.445 0 0 1-.282 1.627c-.115.38-.486.719-.876.799-.072.015-1.263.021-3.994.021-4.198 0-4.013-.004-4.218.1-.046.023-.543.327-1.105.675-.563.349-1.028.63-1.033.623-.021-.02 1.46-9.078 1.507-9.212.111-.324.37-.58.73-.719l.13-.05 3.76-.01c4.129-.011 3.774 0 4.016-.124a.94.94 0 0 0 .457-.56c.064-.213.493-2.878.493-3.057a.94.94 0 0 0-.538-.857c-.19-.091-.311-.11-.72-.11-.24 0-.348-.006-.348-.021 0-.012.083-.536.185-1.165.103-.629.186-1.147.186-1.151 0-.004.6-.005 1.333-.002l1.333.005.13.05c.07.028.168.074.216.102.195.114.394.341.484.552.062.144.104.391.09.525-.03.287-1.033 6.39-1.053 6.411a984.53 984.53 0 0 1-5.503 3.412l-.069.039-1.308-1.043a47.54 47.54 0 0 0-1.385-1.082.583.583 0 0 0-.229-.046c-.127-.006-.166 0-.253.04a.526.526 0 0 0-.28.251.612.612 0 0 0 .064.656c.056.064 2.7 2.176 2.862 2.286.213.144.553.188.814.106.17-.054 5.963-3.636 6.147-3.802a.757.757 0 0 0 .2-.27l.079-.16.516-3.183.539-3.32a3.07 3.07 0 0 0-.01-.786 2.364 2.364 0 0 0-1.573-1.8c-.338-.11-.28-.106-1.904-.111a41.052 41.052 0 0 0-1.582.012Z",
  fill: "#089949"
}, null, -1), m = [
  _
];
function u(e, h, i, f, p, a) {
  return d(), c("svg", {
    "aria-label": i.ariaLabel,
    class: r([a.iconSizeClass, "d-icon d-icon--zoho-desk"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Zoho Desk",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, n);
}
const k = /* @__PURE__ */ o(s, [["render", u]]);
export {
  k as default
};
//# sourceMappingURL=zoho-desk.js.map
